import { useEffect, useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CloseIcon from "../assets/crossIcon.svg";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { AuthServices } from "../services/AuthServices";
import { CircularProgress } from "@mui/material";
import { logOut } from "../config/user";
const ChangePassword = ({ setOpen }) => {
  const [isSaving, setSaving] = useState(false);

  const validationSchema = Yup.object().shape({
    oldPassword: Yup.string().required("Old password is required"),
    newPassword: Yup.string()
      .required("New password is required")
      .min(8, "Password must be at least 8 characters")
      .max(16, "Password must be at most 16 characters")
      .notOneOf(
        [Yup.ref("oldPassword")],
        "New password must be different from old password"
      )
      .test(
        "strong-password",
        "Password must include uppercase, lowercase, number, and special character",
        (value) => {
          if (!value) return false;
          const hasUppercase = /[A-Z]/.test(value);
          const hasLowercase = /[a-z]/.test(value);
          const hasNumber = /[0-9]/.test(value);
          const hasSpecialChar = /[^A-Za-z0-9]/.test(value);
          return hasUppercase && hasLowercase && hasNumber && hasSpecialChar;
        }
      ),
    confirmPassword: Yup.string()
      .required("Please confirm your new password")
      .oneOf([Yup.ref("newPassword")], "Passwords must match"),
  });

  const handleSave = async (values) => {
    setSaving(true);
    try {
      const res = await AuthServices.updatePassword(values);
      window.alert(res?.data?.message);
      logOut();
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setSaving(false);
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="fixed top-0 left-0 h-screen w-screen flex justify-center items-center bg-[#017C5780] z-[1201]">
      <div className="relative h-fit w-[50%] text-[#191919] bg-white p-10 rounded-[20px]">
        <div
          className="absolute top-4 right-4 cursor-pointer"
          onClick={() => setOpen(false)}
        >
          <img src={CloseIcon} alt="close-icon" />
        </div>

        <div className="text-xl font-semibold mb-6">Change Password</div>

        <div className="h-[90%] flex justify-center">
          <Formik
            initialValues={{
              oldPassword: "",
              newPassword: "",
              confirmPassword: "",
            }}
            validationSchema={validationSchema}
            onSubmit={handleSave}
          >
            {() => (
              <Form className="w-[60%] h-[80%] font-medium flex flex-col gap-4 overflow-y-auto">
                <div>
                  <label htmlFor="oldPassword">Enter Old Password</label>
                  <Field
                    type="password"
                    id="oldPassword"
                    name="oldPassword"
                    style={{ border: "1px solid #d5d5d5" }}
                    className="w-full  rounded p-2 mt-1"
                  />
                  <ErrorMessage
                    name="oldPassword"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>

                <div>
                  <label htmlFor="newPassword">Enter New Password</label>
                  <Field
                    type="password"
                    id="newPassword"
                    name="newPassword"
                    style={{ border: "1px solid #d5d5d5" }}
                    className="w-full  rounded p-2 mt-1"
                  />
                  <ErrorMessage
                    name="newPassword"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>

                <div>
                  <label htmlFor="confirmPassword">Re-enter New Password</label>
                  <Field
                    type="password"
                    id="confirmPassword"
                    name="confirmPassword"
                    style={{ border: "1px solid #d5d5d5" }}
                    className="w-full  rounded p-2 mt-1"
                  />
                  <ErrorMessage
                    name="confirmPassword"
                    component="div"
                    className="text-red-500 text-sm"
                  />
                </div>

                <div className="w-full flex justify-center ">
                  {isSaving ? (
                    <CircularProgress />
                  ) : (
                    <button
                      type="submit"
                      className="bg-[#017C57] text-white border-none mt-4 py-3 px-8 rounded-full cursor-pointer"
                    >
                      Save
                    </button>
                  )}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
